<template>
  <div
    v-if="showLoadingState < 2"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingMySalesRecord"
  >
    <div class="m-edition-billing-my-sales-record-info">
      <div class="m-edition-billing-my-sales-record-info-left">
        <div class="m-card-record-info">
          <h4>{{ $t('mEditionBillingMySalesRecord.infoLeft.title') }}</h4>
          <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-history"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.labelState') }}
              <span :class="[$filters.getSaleStateValue(venta.venta.venta_estado, 'class'), 'font-weight-bold']">
                {{ $filters.getSaleStateValue(venta.venta.venta_estado, 'name') }}
              </span>
               {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.fromDate') }}
               <span class="text-transform-capitalize">
                 {{ $moment.parseZone(venta.venta.fecha_venta).format('D MMMM, YYYY') }}
               </span>
            </span>
          </p>
          <p v-if="venta.venta.fecha_cancelar_venta">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.cancelDate') }}
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone(venta.venta.fecha_cancelar_venta).format('D MMMM, YYYY') }}
              </span>
            </span>
          </p>
          <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-receipt"></i>
            </span>
            <span>
              {{ venta.venta.concepto_venta }}
            </span>
          </p>
          <p v-if="venta.venta.id_plan && venta.venta.precio">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-dollar-sign"></i>
            </span>
            <span v-if="venta.venta.venta_estado === 4 || venta.venta.venta_estado === 5 || venta.venta.venta_estado === 8">
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.total') }} {{ venta.venta.divisa }}
              <span class="font-weight-bold">
                {{ venta.venta.total.toFixed(2) }}
              </span>
              <span class="text-color-black-35">
                {{ venta.venta.divisa_iso_code }}
              </span>
            </span>
            <span v-else-if="venta.venta.pago_cuotas">
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.montoParcial') }} {{ venta.venta.divisa }}
              <span class="font-weight-bold">
                {{ venta.venta.total.toFixed(2) }}
              </span>
              <span>
                {{ venta.venta.divisa_iso_code }}
              </span>
              <span class="text-color-black-35">&sol;
                {{ venta.venta.divisa }}
                {{ (venta.venta.precio * venta.venta.pago_cuotas).toFixed(2) }}
                {{ venta.venta.divisa_iso_code }}
              </span>
            </span>
            <span v-else>
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.montoParcial') }} {{ venta.venta.divisa }}
              <span class="font-weight-bold">
                {{ venta.venta.total.toFixed(2) }}
              </span>
              <span class="text-color-black-35">
                {{ venta.venta.divisa_iso_code }}
              </span>
            </span>
          </p>
          <p v-else>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-dollar-sign"></i>
            </span>
            <span class="font-weight-bold">
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.free') }}
            </span>
          </p>
          <p v-if="venta.venta.id_plan && venta.venta.precio">
            <span class="info-icon-left info-icon-billing">
              <i class="far fa-credit-card"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.plan.first') }}
              <span class="font-weight-bold">
                {{ $utils.getPaymentFrequency(venta.venta.pago_cuotas, venta.venta.pago_frecuencia, venta.venta.pago_intervalo) }}
                {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.plan.second') }}
                {{ venta.venta.divisa }}
                {{ venta.venta.precio.toFixed(2) }}
              </span>
                <span class="text-color-black-35">
                  {{ venta.venta.divisa_iso_code }}
                </span>
                {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.plan.third') }} {{ venta.venta.medio_pago }}
            </span>
          </p>
          <p v-if="venta.venta.trial_precio">
            <span class="info-icon-left info-icon-billing">
              <i class="far fa-clock"></i>
            </span>
            <span>
             {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.trialPay.first') }}
              <span class="font-weight-bold">
               {{ venta.venta.divisa }}
               {{ venta.venta.trial_precio.toFixed(2) }}
              </span>
                <span class="text-color-black-35">
                  {{ venta.venta.divisa_iso_code }}
                </span>
                {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.trialPay.second') }} {{ venta.venta.medio_pago }}
            </span>
          </p>
          <p v-if="venta.venta.trial_intervalo">
            <span class="info-icon-left info-icon-billing">
              <i class="far fa-clock"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.trial') }}
              <span class="font-weight-bold">
                {{ venta.venta.trial_intervalo }}
                {{ $filters.getFrequencyValue(venta.venta.trial_frecuencia, 'name') }}
              </span>
            </span>
          </p>
          <p v-if="venta.venta.cupon_codigo">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-percentage"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.cupon.line1') }}
              <span class="font-weight-bold">
                {{ venta.venta.cupon_codigo }}
              </span>
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.cupon.line2') }}
              <span class="font-weight-bold">
               {{ venta.venta.cupon_monto }}%
              </span>
            </span>
          </p>
          <p v-if="venta.iva">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-percentage"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.iva') }}
              <span>
                {{ venta.iva }}%
              </span>
            </span>
          </p>
          <p v-if="venta.venta.medio_pago && venta.venta.id_externo">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-key"></i>
            </span>
            <span>
              {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.suscripcion.idExterno') }}
              <span>
                {{ venta.venta.medio_pago }}
              </span>
              <i class="text-color-black-65 font-weight-bold">
                {{ venta.venta.id_externo }}
              </i>
            </span>
          </p>
          <div v-if="venta.venta.fecha_proximo_pago">
            <p v-if="venta.venta.fecha_inicio_suscripcion && $moment.parseZone().isBefore($moment.parseZone(venta.venta.fecha_inicio_suscripcion))">
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-day"></i>
            </span>
              <span>
              {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.payNext') }}
              <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                {{ $moment.parseZone(venta.venta.fecha_inicio_suscripcion).format('D MMMM, YYYY') }}
              </span>
            </span>
            </p>
            <p v-else>
              <span class="info-icon-left info-icon-billing">
                <i class="fas fa-calendar-day"></i>
              </span>
              <span>
                {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.subscription.payNext') }}
                <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
                  {{ $moment.parseZone(venta.venta.fecha_proximo_pago).format('D MMMM, YYYY') }}
                </span>
              </span>
            </p>
          </div>
          <p
            v-if="venta.proyectos && venta.proyectos.length"
            style="align-items:baseline !important;"
          >
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-list"></i>
            </span>
            <ul style="list-style: none; margin: 0; padding: 0;">
              <li style="padding-bottom: 10px">
                <span class="font-weight-bold">
                  {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.projects') }}
                </span>
              </li>
              <li
                v-for="(proyecto, index) in venta.proyectos"
                :key="index"
                style="font-style: italic; padding-bottom: 5px;"
              >
                <span>
                  - {{ proyecto.titulo}}
                </span>
              </li>
            </ul>
          </p>
          <p
            v-if="venta.satelites && venta.satelites.length"
            style="align-items:baseline !important;"
          >
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-satellite"></i>
            </span>
            <ul style="list-style: none; margin: 0; padding: 0;">
              <li style="padding-bottom: 10px">
                <span class="font-weight-bold">
                  {{ $t('mEditionBillingMySalesRecord.infoLeft.venta.satellites') }}
                </span>
              </li>
              <li
                v-for="(satelite, index) in venta.satelites"
                :key="index"
                style="font-style: italic; padding-bottom: 5px;"
              >
                <!-- "Juedroop · Básico": con dos Droops en el producto, el título solo no dice cuál es -->
                <span>
                  - {{ [satelite.tipo_nombre, satelite.titulo].filter(Boolean).join(' · ') }}
                </span>
              </li>
            </ul>
          </p>
        </div>
      </div>

      <div class="m-edition-billing-my-sales-record-info-right">

        <div class="m-card-record-info">
          <h4>{{ $t('mEditionBillingMySalesRecord.infoRight.customer.title') }}</h4>
          <p class="display-block">{{ venta.cliente.datos_personales.razon_social }}&nbsp;&bull;&nbsp;{{ venta.cliente.email }}</p>
          <p class="display-block">
            <span>
              {{ $filters.getPersonValue(+venta.cliente.datos_personales.fisica, 'name') }}&nbsp;
            </span>
            <span v-if="(venta.cliente.datos_personales.documento && venta.cliente.datos_personales.documento.numero) && (venta.cliente.datos_personales.documento.numero !== '0' && venta.cliente.datos_personales.documento.numero !== 0)">
              &bull;&nbsp;
            </span>
            <span v-if="venta.cliente.datos_personales.documento && venta.cliente.datos_personales.documento.tipo.id_documento_tipo !== 1 &&  venta.cliente.datos_personales.documento.tipo.nombre !== 'ID' && venta.cliente.datos_personales.documento.numero">
              {{ venta.cliente.datos_personales.documento.tipo.nombre }}
              {{ venta.cliente.datos_personales.documento.numero }}
            </span>
          </p>
          <p class="display-block">
            <span> {{ venta.cliente.datos_personales.domicilio.provincia.pais.nombre }} </span>
            <span>, {{ venta.cliente.datos_personales.domicilio.provincia.nombre }} </span>
            <span v-if="venta.cliente.datos_personales.domicilio.localidad">
              , {{ venta.cliente.datos_personales.domicilio.localidad }}
            </span>
            <span v-if="venta.cliente.datos_personales.domicilio.codigo_postal">
              , {{ venta.cliente.datos_personales.domicilio.codigo_postal }}
              </span>
            <span v-if="venta.cliente.datos_personales.domicilio.linea1">
              , {{ venta.cliente.datos_personales.domicilio.linea1 }} </span>
            <span v-if="venta.cliente.datos_personales.domicilio.linea2">
              {{ venta.cliente.datos_personales.domicilio.linea2 }} </span>
          </p>
          <p class="display-block">
            <span v-if="venta.cliente.datos_personales.telefono">
              Teléfono
              {{ venta.cliente.datos_personales.telefono }}
            </span>
            <span v-if="venta.cliente.datos_personales.telefono && venta.cliente.datos_personales.movil">
              &nbsp;&bull;&nbsp;
            </span>
            <span v-if="venta.cliente.datos_personales.movil">
              Móvil
              {{ venta.cliente.datos_personales.movil }}
            </span>
          </p>
        </div>

        <div
          v-if="venta.usuarioActor"
          class="m-card-record-info width-auto"
        >
          <h4 class="text-transform-capitalize">
            {{ $filters.getActorValue(venta.usuarioActor.tipo, 'name').toUpperCase() }}
          </h4>
          <p>
            <span class="display-flex-row-center">
              <AtomAvatarSecondary
                avatar-class="large"
                :user-image="venta.usuarioActor.avatar"
              />
              <span class="display-flex-column margin-left-medium">
                <span v-if="venta.usuarioActor.nombre">
                  {{ venta.usuarioActor.nombre }}
                </span>
                <span class="font-size-xsmall font-weight-light">
                  {{ venta.usuarioActor.email }}
                </span>
                <span class="font-size-xsmall font-weight-light">
                  {{ venta.usuarioActor.estado ? 'Activo' : 'Inactivo' }}
                  {{ $t('mEditionBillingMySalesRecord.infoRight.user.from') }}
                  {{ $moment(venta.usuarioActor.fecha_alta).format('D MMMM, YYYY') }}
                </span>
              </span>
            </span>
          </p>
        </div>
      </div>
    </div>

    <h4 class="font-weight-bold">{{ $t('mEditionBillingMySalesRecord.table.title') }}</h4>
    <div class="m-table-secondary">
      <table class="table-layout-fixed">
        <tr v-show="pagos.length">
          <th
            class="text-align-left"
            width="12%"
          >
            {{ $t('mEditionBillingMySalesRecord.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingMySalesRecord.table.thState') }}
          </th>
          <th
            class="text-align-center"
            width="14%"
          >
            {{ $t('mEditionBillingMySalesRecord.table.thAmount') }}
          </th>
          <th
            class="text-align-center"
            width="7%"
          >
            {{ $t('mEditionBillingMySalesRecord.table.thTax') }}
          </th>
          <th
            class="text-align-center"
            width="17%"
          >
            {{ $t('mEditionBillingMySalesRecord.table.thMethod') }}
          </th>
          <th
            class="text-align-center"
            width="16%"
          >
            {{ $t('mEditionBillingMySalesRecord.table.thToPay') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
            {{ $t('mEditionBillingMySalesRecord.table.thInvoice') }}
          </th>
          <th
            class="text-align-center"
            width="11%"
          >
            {{ $t('mEditionBillingMySalesRecord.table.thAccion') }}
          </th>
        </tr>
        <tr
          v-for="(pago, index) in pagos"
          :key="index"
          class="row-data"
        >
          <td
            class="text-align-left text-transform-capitalize text-white-space-nowrap">
            {{ paymentDate(pago) }}
          </td>
          <td class="text-align-center">
            <span :class="[$filters.getPaymentStateValue(pago.pago_estado, 'class'), 'font-weight-bold']">
              {{ $filters.getPaymentStateValue(pago.pago_estado, 'name') }}
            </span>
          </td>
          <td class="text-align-center">
            {{ pago.divisa_simbolo }} {{ pago.monto.toFixed(2) }} <span class="text-color-black-35"> {{ pago.divisa }}</span>
          </td>
          <td class="text-align-center">
            <span class="text-color-black-35">{{ `(${pago.tipo_impuesto})` }}</span> {{ pago.impuesto }}%
          </td>
          <td class="text-align-center">
            {{ pago.medio_pago }}
          </td>
          <td class="text-align-center">
            <span v-if="showLoading">
              <i
                key="loadingIcon"
                class="fas fa-spinner fa-spin"
                style="color: var(--color-brand-billing-primary)"
              >
              </i>
            </span>
            <span v-else>
              {{ getDetalleAPagar(pago.plan_cuotas, pago.trial_pago !== undefined ? pago.trial_pago : false, index) }}
            </span>
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.invoice"
              @gotToInvoice="gotToInvoice(pago, index)"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              v-if="((pago.pago_estado > 0 && pago.pago_estado !== 2) || ((venta.venta.venta_estado === 7) ||
              (venta.suscripcion && venta.suscripcion.fecha_inicio && $moment.parseZone().isBefore($moment.parseZone(venta.suscripcion.fecha_inicio)))))"
              key="disabled"
              :button-icon-rounded="pago.pago_estado === 0 ? buttonIconRounded.disabledConfirm : buttonIconRounded.disabledRefund"
            />
            <AtomButtonIconRounded
              v-else-if="!pago.pago_estado && pago.medio_pago_manual"
              key="confirmar"
              :button-icon-rounded="buttonIconRounded.confirm"
              :element="{ pago: Object.assign(pago, { detalle: getDetalleAPagar(pago.plan_cuotas, pago.trial_pago !== undefined ? pago.trial_pago : false, index)})}"
              @updatePayment="$modal.showModal"
            />
            <AtomButtonIconRounded
              v-else-if="pago.pago_estado === 2"
              key="reembolsar"
              :button-icon-rounded="buttonIconRounded.refund"
              :element="{ pago: Object.assign(pago, { detalle: getDetalleAPagar(pago.plan_cuotas, pago.trial_pago !== undefined ? pago.trial_pago : false, index)})}"
              @updatePayment="$modal.showModal"
            />
            <span v-else>
              -
            </span>
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMySalesRecord',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      buttonIconRounded: {
        confirm: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionBillingMySalesModalConfirmPayment',
          icon: 'fas fa-check',
          method: 'updatePayment',
          tooltip: this.$t('mEditionBillingMySalesRecord.tooltips.confirm'),
          type: 'button'
        },

        disabledConfirm: {
          class: 'a-button-secondary a-button-disabled-secondary a-button-icon-rounded',
          component: '',
          icon: 'fas fa-check',
          method: '',
          type: 'button'
        },

        disabledRefund: {
          class: 'a-button-secondary a-button-disabled-secondary a-button-icon-rounded',
          component: '',
          icon: 'fas fa-undo-alt',
          method: '',
          type: 'button'
        },

        invoice: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-file-alt',
          method: 'gotToInvoice',
          tooltip: this.$t('mEditionBillingMySalesRecord.tooltips.invoice'),
          type: 'button'
        },

        refund: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionBillingMySalesModalRefundPayment',
          icon: 'fas fa-undo-alt',
          method: 'updatePayment',
          tooltip: this.$t('mEditionBillingMySalesRecord.tooltips.refund'),
          type: 'button'
        }
      },

      filter: {
        limite: 10,
        pagina: 1
      },

      minExpireDate: '',

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        showLoadingState: false,
        limit: 10,
        totalPages: 1,
        totalQuantity: 0
      },

      pagos: [],
      posi: 0,

      showLoadingState: 0,
      showLoading: true,

      trialPago: false,

      venta: {}
    }
  },

  computed: {
    trial () {
      return this.venta.venta.trial_intervalo &&
        this.venta.suscripcion &&
        this.venta.suscripcion.fecha_inicio &&
        this.$moment.parseZone().isBefore(this.$moment.parseZone(this.venta.suscripcion.fecha_inicio))
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  created () {
    this.readVenta()
    this.readVentaPagos()
  },

  watch: {
    'pagination.currentPage' () {
      this.showLoading = true
      this.posi = this.pagination.currentPage === 1 ? 0 : (this.filter.limite * (this.pagination.currentPage - 1))
    },

    updatedData () {
      this.readVentaPagos(false)
    }
  },

  methods: {
    getDetalleAPagar (cuotas, trial, index) {
      return trial
        ? 'Trial'
        : cuotas === 1
          ? 'Contado'
          : cuotas === 0
            ? `Pago ${(this.pagination.totalQuantity - index) - this.posi}`
            : `Cuota ${(this.pagination.totalQuantity - index) - this.posi} de ${cuotas}`
    },

    getTotalVenta (total = 0, monto, trial, cuotas) {
      return !cuotas
        ? total
        : this.trialPago
          ? (cuotas * monto) + trial
          : (cuotas * monto)
    },

    gotToInvoice (pago, index) {
      this.$store.commit('setBillingPayment', Object.assign({}, pago, { detalle: this.getDetalleAPagar(pago.plan_cuotas, pago.trial_pago !== undefined ? pago.trial_pago : false, index) }))
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.mySales.subject')}/${this.$route.params.subid}/${this.$t('mEditionMenu.billing.mySales.children.invoice.subedition')}/${pago.id_pago}`)
    },

    paymentDate (pago) {
      if (pago.pago_estado === 0) {
        return this.$moment.parseZone(pago.fecha_pago_vencimiento).subtract(5, 'days').format('D MMM YYYY')
      } else if (pago.pago_estado === 2) {
        return this.$moment.parseZone(pago.fecha_pago).format('D MMM YYYY')
      } else {
        return this.$moment.parseZone(pago.fecha_estado).format('D MMM YYYY')
      }
    },

    readVenta () {
      this.$services.read('ventas', 'readVenta', {}, [this.$route.params.subid])
        .then(response => {
          this.venta = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readVentaPagos (alert = true) {
      if (!this.pagination.showLoadingState) {
        alert
          ? this.pagination.showLoadingState = true
          : this.pagination.showLoadingState = false
        this.$services.read('ventas', 'readVentaPagos', {}, [this.$route.params.subid], this.filter)
          .then(response => {
            this.pagos = response.data.pagos
            if (this.pagos.find(p => p.trial_pago === true) !== undefined) {
              this.trialPago = true
            }
            if (!alert) {
              setTimeout(this.readVenta(), 3000)
            }
            this.pagination.currentQuantity = response.data.pagos.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState++
            this.showLoading = false
          })
          .catch(error => {
            console.log(error)
            this.pagos = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState++
          })
      }
    },

    reloadListing () {
      this.setPaginationCurrentPage(1)
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readVentaPagos()
    }
  }
}
</script>
